const seed = 'abcdefghijklmnopqrstuvwxyz';

export const randomCharString = (length: number) => {
    const charSlots = new Array(length).fill('');
    return charSlots.reduce((acc, slot) => {
        const charPos = Math.floor(Math.random() * seed.length);
        return acc + seed[charPos];
    }, ``);
};
